import useApiClient from './api-client'
import type {
  BranchData,
  BranchArrivalTimeInfo,
  FbranchEatigoListData,
  EatigoBranchHeadcountInfo,
  BranchMenuItemsRes,
  BranchBlockStatusRes,
  BranchReviewSummaryData,
} from '@/types/api'
import type { GetBranchArrivalTimesParams, GetBranchesReqParams, GetBranchHeadcountParams } from '@/types/branch'
import type { GeolocationState } from '@/types/commons'

export const getRestaurants = async (params: GetBranchesReqParams) => {
  const api = useApiClient<{ list: FbranchEatigoListData[] }>()
  const { filter_times, ...restParams } = params
  const query = {
    ...restParams,
    ...(filter_times?.length && { 'filter_times[]': filter_times }),
  }
  const result = await api(`/restaurant`, { query })

  return result
}

export const getBranch = async (branchId: number | string, params: GeolocationState = {}) => {
  const api = useApiClient<BranchData>()
  const result = await api(`/restaurant/${branchId}`, { query: params })

  return result
}

export const getBranchArrivalTimes = async (branchId: number | string, params?: GetBranchArrivalTimesParams) => {
  const api = useApiClient<BranchArrivalTimeInfo>()
  const result = await api(`/restaurant/${branchId}/arrivaltimes`, { query: params })

  return result
}

export const getBranchHeadcount = async (branchId: number | string, params: GetBranchHeadcountParams) => {
  const api = useApiClient<EatigoBranchHeadcountInfo>()
  const result = await api(`/restaurant/${branchId}/headcount`, { query: params })

  return result
}

export const getBranchMenuItem = async (branchId: number | string) => {
  const api = useApiClient<BranchMenuItemsRes['data']>()
  const result = await api(`/restaurant/${branchId}/menu-items`)

  return result
}

export const getBranchBLockStatus = async (branchId: number | string) => {
  const api = useApiClient<BranchBlockStatusRes>()
  const result = await api(`/restaurant/${branchId}/block-status`)

  return result
}

export const getBranchReviewSummary = async (branchId: number | string) => {
  const api = useApiClient<BranchReviewSummaryData>()
  const result = await api(`/restaurant/${branchId}/review-summary`)

  return result
}
